import React from 'react'
import { Roller } from 'react-awesome-spinners'

const Loader = () => {
  return (
    <div className='loader text-center pt-5'>
      <Roller />
    </div>
  )
}

export default Loader
